(function () {
    'use strict';

    angular
        .module('core.services')
        .service('PersonService', PersonService)

    /** @ngInject */
    function PersonService(HttpService) {
        const PersonService = {
            requestPasswordChange: requestPasswordChange,
            getDocumentTypes: getDocumentTypes,
            getGenders: getGenders,
            get: get,
            changePassword: changePassword,
            getByParameters: getByParameters,
            getByDocument: getByDocument,
            getConsultants: getConsultants,
            associateToUnit: associateToUnit,
            updateUnitAssociation: updateUnitAssociation,
            put: put
        }

        return PersonService;

        function requestPasswordChange(cpf) {
            return HttpService.get(`/people/documents/${cpf}/reset-password-request`);
        }

        function changePassword(changeData) {
            return HttpService.put('/people/change-password', changeData)
        }

        function getDocumentTypes() {
            return HttpService.get('/people/documents/types');
        }

        function getGenders() {
            return HttpService.get('/people/genders');
        }

        function get(personId) {
            return HttpService.get(`/people/${personId}`);
        }

        function getByParameters(params) {
            return HttpService.get('/people', {
                params
            });
        }

        function getByDocument(document) {
            return HttpService.get(`/people/documents/${document}`);
        }

        function getConsultants() {
            return HttpService.get('/people/consultants');
        }

        function associateToUnit(associationData) {
            return HttpService.post('/people/units', associationData);
        }

        function updateUnitAssociation(associationData) {
            return HttpService.put('/people/units', associationData);
        }

        function put(personData) {
            return HttpService.put('/people', personData);
        }
    }
}());